<template>
<div>
    <div class="class-box">
        <div v-for="(item, index) of classiryList" :key="index" @click="clickNav(index,false)" class="class-item" :class="{'active': item.selected,'active-scenic':item.title=='景点'&&item.selected,'active-food':item.title=='美食'&&item.selected,'active-shopping':item.title=='购物'&&item.selected,'active-hotel':item.title=='住宿'&&item.selected,'active-wc':item.title=='洗手间'&&item.selected,'active-parking':item.title=='停车场'&&item.selected,'active-fun':item.title=='娱乐'&&item.selected,'active-outin':item.title=='出入口'&&item.selected,'active-wifi':item.title=='免费WiFi'&&item.selected,'active-bike':item.title=='骑行'&&item.selected,'active-coupon':item.title=='团购'&&item.selected,'active-servicecenter':item.title=='服务中心'&&item.selected,'active-other':classify.indexOf(item.title)==-1&&item.selected}">
            <div class="class-icon"></div>
            {{item.title}}
        </div>
    </div>
    <!-- 展开全部选择框的按钮 -->
    <div class="class-allBtn" @click="showAll=true"></div>

    <!-- 所有分类的选择框，点击了才显示 -->
    <div class="allClassify-box" :class="{'show':showAll}">
        <div class="top">
            <p>全部</p>
            <p class="close-btn" @click="showAll=false"></p>
        </div>
        <div class="bottom">
            <div v-for="(item, index) of classiryList" :key="index" @click="clickNav(index,true)" :class="{'scenic':item.title=='景点','food':item.title=='美食','shopping':item.title=='购物','hotel':item.title=='住宿','wc':item.title=='洗手间','parking':item.title=='停车场','fun':item.title=='娱乐','outin':item.title=='出入口','wifi':item.title=='免费WiFi','bike':item.title=='骑行','coupon':item.title=='团购','servicecenter':item.title=='服务中心','other':classify.indexOf(item.title)==-1,'active-scenic':item.title=='景点'&&item.selected,'active-food':item.title=='美食'&&item.selected,'active-shopping':item.title=='购物'&&item.selected,'active-hotel':item.title=='住宿'&&item.selected,'active-wc':item.title=='洗手间'&&item.selected,'active-parking':item.title=='停车场'&&item.selected,'active-fun':item.title=='娱乐'&&item.selected,'active-outin':item.title=='出入口'&&item.selected,'active-wifi':item.title=='免费WiFi'&&item.selected,'active-bike':item.title=='骑行'&&item.selected,'active-coupon':item.title=='团购'&&item.selected,'active-servicecenter':item.title=='服务中心'&&item.selected,'active-other':classify.indexOf(item.title)==-1&&item.selected}">
                {{item.title}}
            </div>
        </div>
    </div>

    <!-- mask模态框 -->
    <div class="mask" :class="{'show':showAll}"></div>
</div>
</template>

<script>
import Apis from '../../config/apis'
export default {
    name: 'TopNav',
    props: {
        sid: String
    },
    data() {
        return {
            classiryList: [], // 分类数据
            showAll: false,
            classify:['景点','美食','购物','住宿','洗手间','停车场','娱乐','出入口','免费WiFi','骑行','团购','服务中心']
        }
    },
    mounted() {
        // 获取分类
        // this.getClassifys();
    },
    methods: {
        getClassifys() {
            console.log(12)
            let allClassifyUrl = Apis.allClassify
            if(this.sid) allClassifyUrl = Apis.allClassify1
            this.axios.post(allClassifyUrl, {
                sid: this.sid
            }).then(res => {
                console.log(123, 'top  getClassifys')
                // 判断之前是否有选中的分类
                const curClassify = this.$store.state.curClassify
                console.log(1234, 'top getClassifys')
                if (curClassify == '') {
                    res.data.map((el, ix) => {
                        el['selected'] = ix === 0 ? true : false
                    })
                    // 设置全局当前选中的分类
                    this.$store.commit('setCurClassify', res.data[0])
                } else {
                    res.data.map(el => {
                        if (el.id == curClassify.id) {
                            el['selected'] = true
                            // 设置全局当前选中的分类
                            this.$store.commit('setCurClassify', el)
                        } else {
                            el['selected'] = false
                        }
                    })
                }
                this.classiryList = res.data
                this.setClassify()
            })
        },
        setClassify() {
            let cid = this.$route.query.cid,
                idx = 0
            if(cid) {
                idx = this.classiryList.findIndex(item => item.id == cid)
                this.clickNav(idx, true)
            }
        },
        /**
         * @param idx 选择的分类的下标
         * @param needScroll 选择分类后是否需要横向滚动（在全部分类弹框里选择分类后需要滚动）
         */
        clickNav(idx, needScroll) {
            this.classiryList.map((el, ix) => {
                el.selected = ix === idx ? true : false
            })
            // 设置全局当前选中的分类
            this.$store.commit('setCurClassify', this.classiryList[idx])
            // 选择分类后关闭全部分类选择框
            this.showAll = false
            // 选择分类后滚动条位置滚动
            let element = document.getElementsByClassName('class-box')
            if (needScroll) {
                // 下标大于等于5才滚动一定位置，否则滚动条位置为0
                this.$nextTick(() => {
                    idx >= 4 ? element[0].scrollLeft = idx * 65 : element[0].scrollLeft = 0
                })
            }

        }
    }
}
</script>

<style lang="scss">
.class-box {
    display: flex;
    flex-wrap: nowrap;
    font-size: .32rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    // margin-right: 1rem;
    height: 1rem;
    line-height: 1rem;
    padding-left: .3rem;
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100vw - 1rem);

    .class-item {
        height: .7rem;
        line-height: .7rem;
        padding: 0 .3rem;
        white-space: nowrap;
        margin: auto 0;
        transition: .2s ease;

        &.active {
            color: #fff;
            padding-right: .2rem;
            border-radius: 35px;
        }
        .class-icon {
            display: none;
            width: .4rem;
            height: .4rem;
        }
        .common-icon {
            display: inline-block;
            vertical-align: sub;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
        }
        &.active-scenic {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_scenic.png');
            }
            background-image: linear-gradient(90deg,rgba(54,147,125,1),rgba(63,184,155,1));
        }

        &.active-food {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_food.png');
            }
            background-image: linear-gradient(90deg,rgba(254,117,112,1),rgba(255,83,76,1));
        }

        &.active-shopping {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_shopping.png');
            }
            background-image: linear-gradient(90deg,rgba(254,117,112,1),rgba(255,83,76,1));
        }

        &.active-hotel {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_hotel.png');
            }
            background-image: linear-gradient(90deg,rgba(68,167,198,1),rgba(77,180,213,1));
        }

        &.active-wc {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_wc.png');
            }
            background-image: linear-gradient(90deg,rgba(93,144,208,1),rgba(112,161,222,1));
        }

        &.active-parking {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_parking.png');
            }
            background-image: linear-gradient(90deg,rgba(68,167,198,1),rgba(77,180,213,1));
        }

        &.active-fun {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_fun.png');
            }
            background-image: linear-gradient(90deg,rgba(125,95,169,1),rgba(143,110,193,1));
        }

        &.active-outin {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_outin.png');
            }
            background-image: linear-gradient(90deg,rgba(93,144,208,1),rgba(112,161,222,1));
        }

        &.active-wifi {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_wifi.png');
            }
            background-image: linear-gradient(90deg,rgba(68,167,198,1),rgba(77,180,213,1));
        }

        &.active-bike {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_bike.png');
            }
            background-image: linear-gradient(90deg,rgba(54,147,125,1),rgba(63,184,155,1));
        }

        &.active-coupon {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_coupon.png');
            }
            background-image: linear-gradient(90deg,rgba(254,117,112,1),rgba(255,83,76,1));
        }

        &.active-servicecenter {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_servicecenter.png');
            }
            background-image: linear-gradient(90deg,rgba(254,117,112,1),rgba(255,83,76,1));
        }

        &.active-other {
            .class-icon {
                @extend .common-icon;
                background-image: url('../../assets/classify_icon_other.png');
            }
            background-image: linear-gradient(90deg,rgba(68,167,198,1),rgba(77,180,213,1));
        }
    }
}

.class-box::-webkit-scrollbar {
        display: none;
}

.class-allBtn {
        position: fixed;
        right: 0;
        top: 0;
        width: 1rem;
        height: 1rem;
        background: #fff url('../../assets/classify_allbtn_icon.png') no-repeat center center/ .4rem .4rem;
    }

.allClassify-box {
    width: 100%;
    background-color: #fff;
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    transform: translateY(-1000%);
    transition: transform .3s;

    .top {
        padding: .35rem .3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: .32rem;
        color: #999999;

        .close-btn {
            width: .4rem;
            height: .4rem;
            background: url('../../assets/classify_close_icon.png') no-repeat center center/.4rem .4rem;
        }
    }

    .bottom {
        font-size: .28rem;
        color: #7E7E7E;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: .6rem;

        div {
            width: 25%;
            padding-top: .8rem;
            margin-top: .6rem;
        }

        .scenic {
            background: url('../../assets/classify_all_scenic.png') no-repeat center .2rem/.6rem .6rem;
        }

        .food {
            background: url('../../assets/classify_all_food.png') no-repeat center .2rem/.6rem .6rem;
        }

        .shopping {
            background: url('../../assets/classify_all_shopping.png') no-repeat center .2rem/.6rem .6rem;
        }

        .hotel {
            background: url('../../assets/classify_all_hotel.png') no-repeat center .2rem/.6rem .6rem;
        }

        .wc {
            background: url('../../assets/classify_all_wc.png') no-repeat center .2rem/.6rem .6rem;
        }

        .parking {
            background: url('../../assets/classify_all_parking.png') no-repeat center .2rem/.6rem .6rem;
        }

        .fun {
            background: url('../../assets/classify_all_fun.png') no-repeat center .2rem/.6rem .6rem;
        }

        .outin {
            background: url('../../assets/classify_all_outin.png') no-repeat center .2rem/.6rem .6rem;
        }

        .wifi {
            background: url('../../assets/classify_all_wifi.png') no-repeat center .2rem/.6rem .6rem;
        }

        .bike {
            background: url('../../assets/classify_all_bike.png') no-repeat center .2rem/.6rem .6rem;
        }

        .coupon {
            background: url('../../assets/classify_all_coupon.png') no-repeat center .2rem/.6rem .6rem;
        }

        .servicecenter {
            background: url('../../assets/classify_all_servicecenter.png') no-repeat center .2rem/.6rem .6rem;
        }

        .other {
            background: url('../../assets/classify_all_other.png') no-repeat center .2rem/.6rem .6rem;
        }

        .active-scenic {
            background: url('../../assets/classify_allactive_scenic.png') no-repeat center .2rem/.6rem .6rem;
            color: #36937D;
        }

        .active-food {
            background: url('../../assets/classify_allactive_food.png') no-repeat center .2rem/.6rem .6rem;
            color: #FE7570;
        }

        .active-shopping {
            background: url('../../assets/classify_allactive_shopping.png') no-repeat center .2rem/.6rem .6rem;
            color: #FF534C;
        }

        .active-hotel {
            background: url('../../assets/classify_allactive_hotel.png') no-repeat center .2rem/.6rem .6rem;
            color: #44A7C6;
        }

        .active-wc {
            background: url('../../assets/classify_allactive_wc.png') no-repeat center .2rem/.6rem .6rem;
            color: #5D90D0;
        }

        .active-parking {
            background: url('../../assets/classify_allactive_parking.png') no-repeat center .2rem/.6rem .6rem;
            color: #4DB4D5;
        }

        .active-fun {
            background: url('../../assets/classify_allactive_fun.png') no-repeat center .2rem/.6rem .6rem;
            color: #7D5FA9;
        }

        .active-outin {
            background: url('../../assets/classify_allactive_outin.png') no-repeat center .2rem/.6rem .6rem;
            color: #5D90D0;
        }

        .active-wifi {
            background: url('../../assets/classify_allactive_wifi.png') no-repeat center .2rem/.6rem .6rem;
            color: #4DB4D5;
        }

        .active-bike {
            background: url('../../assets/classify_allactive_bike.png') no-repeat center .2rem/.6rem .6rem;
            color: #36937D;
        }

        .active-coupon {
            background: url('../../assets/classify_allactive_coupon.png') no-repeat center .2rem/.6rem .6rem;
            color: #FE7570;
        }

        .active-servicecenter {
            background: url('../../assets/classify_allactive_servicecenter.png') no-repeat center .2rem/.6rem .6rem;
            color: #FE7570;
        }

        .active-other {
            background: url('../../assets/classify_allactive_other.png') no-repeat center .2rem/.6rem .6rem;
            color: #4DB4D5;
        }
    }
}

.allClassify-box.show {
    transform: translateY(0);
    transition: transform .3s;
}

.mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0;
    z-index: -1;
    transition: opacity .3s;
}

.mask.show {
    opacity: .5;
    z-index: 500;
    transition: opacity .3s;
}
</style>
